<template>
  <div v-if="$store.getters.retrieveAnon">
    <v-card flat>
      <v-stepper
        v-model="currentStep"
        class="elevation-0"
        style="background-color: var(--v-background-base)"
      >
        <v-stepper-header>
          <v-stepper-step :complete="currentStep > 1" step="1">
            User Info
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="currentStep > 2"
            >Delivery Information</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step step="3">Complete</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-card-text class="py-0" style="text-align: end">
            <v-btn
              v-if="currentStep != 1"
              text
              exact
              @click="previousStep"
              color="blue darken-2"
            >
              <v-icon left>arrow_back</v-icon>Previous
            </v-btn>
          </v-card-text>
          <v-stepper-content step="1">
            <v-card-text>
              <v-alert class="text-left" border="left" text type="info">
                <div>
                  Please sign up for an account in order to check out, we just
                  need some basic contact information in case we need to get in
                  touch about your order.
                </div>
                <div>
                  You'll be able to sign in with the information entered below
                  if you want to place another order in the future.
                </div>
              </v-alert>
            </v-card-text>
            <UserInfoForm
              :userDetails="userInfo"
              :error="userInfoError"
              :errorMessage="userInfoErrorMessage"
              @valid-user-info="validUserInfo"
            ></UserInfoForm>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-alert
              v-if="this.$store.getters.retrieveIsCncCustomer"
              class="text-left"
              border="left"
              text
              type="info"
            >
              Please enter your delivery information so that if we start
              delivering to your postcode your account will automatically be
              eligible to get delivery orders.
            </v-alert>
            <DeliveryInfoForm
              :deliveryAddress="deliveryInfo"
              :error="error"
              :errorMessage="errorMessage"
              :onRegister="validDeliveryInfo"
              :loading="loading"
            ></DeliveryInfoForm>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card>
              <div v-if="getSurveyData">
                <v-card-title v-if="getSurveyData.hear_no == null">
                  <v-icon class="mr-2">hearing</v-icon>Hear About
                </v-card-title>
                <v-card-subtitle v-if="getSurveyData.hear_no == null"
                  >Please let us know how you heard about us.</v-card-subtitle
                >
                <v-card-text v-if="getSurveyData.hear_no == null">
                  <v-radio-group v-model="hear_no">
                    <v-radio
                      v-for="(hear_item, index) in getSurveyData.hear_about"
                      :key="index"
                      :label="hear_item.hear_desc"
                      :value="hear_item.hear_no"
                      color="blue darken-2"
                    ></v-radio>
                  </v-radio-group>
                </v-card-text>
              </div>

              <v-card-title>
                <v-icon class="mr-2">mdi-message-text</v-icon>Marketing
                Communications
              </v-card-title>

              <v-card-text>
                <v-checkbox
                  v-model="contact_email"
                  :false-value="0"
                  :true-value="1"
                  label="Allow Contact By Email"
                  color="blue darken-2"
                ></v-checkbox>
                <v-checkbox
                  v-model="contact_sms"
                  :false-value="0"
                  :true-value="1"
                  label="Allow Contact By SMS"
                  color="blue darken-2"
                ></v-checkbox>
                <v-checkbox
                  v-model="contact_tel"
                  :false-value="0"
                  :true-value="1"
                  label="Allow Contact By Telephone"
                  color="blue darken-2"
                ></v-checkbox>
                <v-checkbox
                  v-model="contact_post"
                  :false-value="0"
                  :true-value="1"
                  label="Allow Contact By Post"
                  color="blue darken-2"
                ></v-checkbox>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="submit" :loading="loading">
                  Complete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <!-- </v-dialog> -->
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

import UserInfoForm from "@/components/auth/UserInfoForm.vue";
import DeliveryInfoForm from "@/components/auth/DeliveryInfoForm.vue";

export default {
  props: {
    bottom: Boolean,
  },

  components: {
    UserInfoForm,
    DeliveryInfoForm,
  },

  data() {
    return {
      loading: false,

      currentStep: 1,

      contact_email: 1,
      contact_sms: 1,
      contact_tel: 1,
      contact_post: 1,

      error: "",
      errorMessage: "",
      userInfoError: "",
      userInfoErrorMessage: "",

      getSurveyData: null,
      hear_no: null,
    };
  },

  async mounted() {
    await this.getSurvey();
  },

  activated() {
    if (!this.$store.getters.retrieveAnon) {
      this.$router.push({ name: "OrdersBasket" });
    }
  },

  computed: {
    ...mapGetters([
      "retrieveUser",
      "retrieveCustomerAddress",
      "retrieveCustomer",
    ]),

    disableAnonSubmit() {
      return !this.$store.getters.retrieveCurrentTrolly.trolly_valid_anon;
    },

    userInfo() {
      return {
        userName: "",
        email: "",
        telephone: "",
        password: "",
        confirmPassword: "",
      };
    },
    deliveryInfo() {
      return {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postcode: this.retrieveCustomerAddress.postcode,
      };
    },
  },

  methods: {
    ...mapActions([
      "getCustomer",
      "setSnackbar",
      "authUser",
      "getCustomer",
      "getTrollys",
      "setAnonUser",
      "updateUserDetails",
      "setAnonUser",
      "getSelectedDeliveryAddress",
    ]),

    async getSurvey() {
      console.log(" -- Get Survey");
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("get-survey", params)
        .then((response) => {
          if (response.data.success == true) {
            this.getSurveyData = response.data;

            console.log("-- Home Survey Data");
            console.log(response.data);

            // if (response.data.cookies_accept == null) {
            //   this.showDialog = true;

            //   console.log("-- Re-va;odat");
            //   console.log(this.getSurveyData);
            // }

            return response.data.success;
          } else {
            return response.data.success;
          }
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
    },

    nextStep() {
      this.currentStep = this.currentStep + 1;
    },
    previousStep() {
      this.currentStep = this.currentStep - 1;
    },

    validUserInfo() {
      console.log("-- Valid user Info");
      console.log(this.userInfo);

      //If the user is CNC only let them checkout
      //-- Otherwise collect the delivery info
      this.nextStep();
    },

    validDeliveryInfo() {
      console.log("-- Valid Delivery Info");
      console.log(this.userInfo);

      //If the user is CNC only let them checkout
      //-- Otherwise collect the delivery info
      this.nextStep();
    },

    async submit() {
      console.log("-- Finished Form");
      this.loading = true;

      this.error = false;
      this.errorMessage = "";

      const params = {
        userId: this.retrieveUser.userNum,
        sessionKey: this.retrieveUser.sessionKey,
        password: this.userInfo.password.trim(),
        userName: this.userInfo.userName.trim(),
        email_address: this.userInfo.email.trim(),
        telephone: this.userInfo.telephone.trim(),
        address_line_1: this.deliveryInfo.addressLine1.trim(),
        address_line_2: this.deliveryInfo.addressLine2.trim(),
        address_line_3: this.deliveryInfo.addressLine3.trim(),
        address_line_4: this.deliveryInfo.addressLine4.trim(),
        postcode: this.deliveryInfo.postcode.trim(),
        contact_email: this.contact_email,
        contact_sms: this.contact_sms,
        contact_tel: this.contact_tel,
        contact_post: this.contact_post,
        hear_no: this.hear_no,
        isNewUser: true,
      };

      const response = await this.updateUserDetails(params);

      if (response) {
        if (response.success == true) {
          console.log("Fetch Customer Now");
          this.getCustomer()
            .then((response) => {
              if (response.success == true) {
                this.setAnonUser(false);

                this.getSelectedDeliveryAddress();

                this.$router.push({ name: "OrdersCheckout" });
              } else {
                this.setSnackbar({
                  text: "Error Loading Customer",
                  color: "error",
                });
                console.log("Error Loadig Customer");
              }
            })
            .catch((er) => {
              console.log(er);
            });
        } else {
          this.error = true;
          this.errorMessage = response.message;
          this.setSnackbar({ text: response.message, color: "error" });
          console.log("Error Updating User");
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>